<template>
  <div>
    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs class="tab-action-btn-fill-conatiner">
          <vs-tab label="Conta" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <div>
                <!-- Content Row -->
                <div class="vx-row">
                  <div class="vx-col md:w-1/3 w-full">
                    <vs-input class="w-full" label="Nome" v-model="data.name" name="name" />
                    <vs-input class="w-full mt-4" label="Email" v-model="data.email" type="email" name="email" />
                    <vs-input class="w-full mt-4" label="CPF/CNPJ" v-model="data.cpfcnpj" name="cpfcnpj" />
                    <vs-input class="w-full mt-4" label="Telefone" v-model="data.telephone" name="telephone" />
                  </div>

                  <div class="vx-col md:w-1/3 w-full">
                    <vs-input class="w-full" label="Endereço" v-model="data.address_street" name="street" />
                    <vs-input class="w-full mt-4" label="Número" v-model="data.address_number" name="number" />
                    <vs-input class="w-full mt-4" label="Bairro" v-model="data.address_complement" name="complement" />
                    <vs-input class="w-full mt-4" label="Cidade" v-model="data.address_city" name="city" />
                  </div>

                  <div class="vx-col md:w-1/3 w-full">
                    <div class="vx-col w-full">
                      <vs-radio v-model="data.status" :vs-value="1" vs-name="status" class="mr-4">Ativo</vs-radio>
                      <vs-radio v-model="data.status" :vs-value="2" vs-name="status" class="mr-4">Bloqueado</vs-radio>
                    </div>
                    <div class="vx-col w-full" v-show="data.status === 2">
                      <vs-radio v-model="data.status_reason" :vs-value="1" vs-name="status_reason" class="mr-4"
                        >Disputa de pagamento
                      </vs-radio>
                      <vs-radio v-model="data.status_reason" :vs-value="2" vs-name="status_reason" class="mr-4"
                        >Bloqueio de Segurança
                      </vs-radio>
                    </div>
                  </div>
                </div>
                <!-- Save & Reset Button -->
                <div class="vx-row mt-8">
                  <div class="vx-col w-full md:w-6/12">
                    <div class="flex flex-wrap justify-end">
                      <vs-button icon-pack="feather" icon="icon-save" class="ml-auto mt-2" @click="save"
                        >Salvar
                      </vs-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </vs-tab>

          <vs-tab
            :label="'Celulares (' + data.mobile.length + ')'"
            icon-pack="feather"
            icon="icon-info"
            :disabled="!data.id"
          >
            <div class="tab-text">
              <div>
                <div class="flex flex-row gap-x-2 py-4 mb-2">
                  <div class="flex-1 px-2">
                    <vs-input class="w-full inputx" placeholder="Nome do dispositivo" v-model="filters.device" />
                  </div>

                  <div class="flex-1 px-2">
                    <v-select
                      :closeOnSelect="true"
                      v-model="filters.status.selected"
                      :options="filters.status.options"
                      placeholder="Status"
                    />
                  </div>
                </div>

                <div class="vx-row">
                  <Mobile
                    :device="device"
                    :filters="filters"
                    :editLicence="editLicence"
                    v-for="(device, idx) in data.mobile"
                    :key="idx"
                  />
                </div>
              </div>
            </div>
          </vs-tab>

          <vs-tab
            :label="'Computadores (' + data.desktop.length + ')'"
            icon-pack="feather"
            icon="icon-monitor"
            :disabled="!data.id"
          >
            <div class="tab-text">
              <div>
                <div class="vx-row">
                  <Desktop
                    :device="device"
                    :editLicence="editLicence"
                    v-for="(device, idx) in data.desktop"
                    :key="idx"
                  />
                </div>
              </div>
            </div>
          </vs-tab>

          <vs-tab
            :label="'Licenças (' + data.licences.length + ')'"
            icon-pack="feather"
            icon="icon-check-circle"
            :disabled="!data.id"
          >
            <div class="tab-text" style="min-height: 400px">
              <div class="vx-row mt-4 mb-4 flex">
                <div class="vx-col md:w-3/12 w-full">
                  <div>Plano</div>
                  <v-select class="w-full" :options="plans" :clearable="false" v-model="newLicence.plan" />
                </div>
                <div class="vx-col md:w-3/12 w-full">
                  <div>Quantidade de Licenças</div>
                  <vs-input class="w-full" v-model="newLicence.quantity" />
                </div>
                <div class="vx-col md:w-3/12 w-full">
                  <div>Dias de cada Licença</div>
                  <vs-input class="w-full" v-model="newLicence.days" placeholder="(opcional)" />
                </div>
                <div class="vx-col md:w-3/12 w-full">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-save"
                    color="success"
                    class="w-full mt-5"
                    :disabled="!newLicence.plan"
                    @click="confirmNewLicence = true"
                    >Cadastrar Nova Licença
                  </vs-button>
                </div>
              </div>
              <div class="mt-3 mb-4 w-full">
                <small
                  >Escolha o plano, digite a quantidade de licenças à cadastrar (não é a quantidade de meses, é quantas
                  licenças você quer cadastrar). Caso digite um número de dias, este irá sobrescrever o período do
                  plano. Ex. wSpy Pro - 1 mês, ao digitar a quantidade de dias igual à 7, a licença será gerada com 7
                  dias e não 1 mês.</small
                >
              </div>

              <vs-table class="w-full" noDataText="Nenhum item à listar." :data="data.licences" :stripe="true">
                <template slot="thead">
                  <vs-th class="text-center">ADQUIRIDA EM</vs-th>
                  <vs-th class="text-center">SITUAÇÃO</vs-th>
                  <vs-th class="text-center">USADA EM</vs-th>
                  <vs-th class="text-center">VALIDA ATÉ</vs-th>
                  <vs-th class="text-right">DIAS/MESES</vs-th>
                  <vs-th>CHAVE DE LICENÇA</vs-th>
                  <vs-th>DISPOSITIVO</vs-th>
                  <vs-th>PLANO</vs-th>
                  <vs-th class="text-right">VENDA (ID INTERNA)</vs-th>
                  <vs-th class="text-right">ASSINATURA (ID INTERNA)</vs-th>
                  <vs-th class="text-right">AÇÃO</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :data="tr" v-for="(tr, idx) in data" :key="idx">
                    <vs-td valign="top" class="text-center">{{ data[idx].date_added | formatDateTime }}</vs-td>
                    <vs-td valign="top" v-if="data[idx].active === '1'" class="text-center text-success">Ativa</vs-td>
                    <vs-td valign="top" v-if="data[idx].active === '0'" class="text-center text-danger">Inativa</vs-td>
                    <vs-td valign="top" v-if="data[idx].date_used" class="text-center"
                      >{{ data[idx].date_used | formatDateTime }}
                    </vs-td>
                    <vs-td valign="top" v-if="!data[idx].date_used" class="text-center text-success"
                      >Não Utilizada
                    </vs-td>
                    <vs-td valign="top" v-if="data[idx].date_valid_until" class="text-center"
                      >{{ data[idx].date_valid_until | formatDate }}
                    </vs-td>
                    <vs-td valign="top" v-if="!data[idx].date_valid_until" class="text-center text-success">-</vs-td>
                    <vs-td valign="top" class="text-right" v-if="data[idx].days">{{ data[idx].days }} dias</vs-td>
                    <vs-td valign="top" class="text-right" v-else-if="data[idx].months"
                      >{{ data[idx].months }} meses
                    </vs-td>
                    <vs-td valign="top" class="text-right" v-else>-</vs-td>
                    <vs-td valign="top">{{ data[idx].licencekey || '-' }}</vs-td>
                    <vs-td valign="top">{{ data[idx].device_id || '-' }}</vs-td>
                    <vs-td valign="top" v-if="data[idx].product">{{ data[idx].product.name }}</vs-td>
                    <vs-td valign="top" v-if="!data[idx].product">-</vs-td>
                    <vs-td valign="top" class="text-right">
                      <router-link :to="{ name: 'venda-detalhes', params: { id: data[idx].order_id } }"
                        >{{ data[idx].order_id }}
                      </router-link>
                    </vs-td>
                    <vs-td valign="top" class="text-right">
                      <router-link :to="{ name: 'assinatura-detalhes', params: { id: data[idx].subscription_id } }"
                        >{{ data[idx].subscription_id }}
                      </router-link>
                    </vs-td>
                    <vs-td valign="top" class="text-center">
                      <vs-button
                        color="success"
                        size="small"
                        @click="transferLicence(data, idx)"
                        icon-pack="feather"
                        icon="icon-repeat"
                        class="mb-2"
                      ></vs-button>

                      <vs-button
                        color="danger"
                        size="small"
                        @click="deleteLicence(data, idx)"
                        icon-pack="feather"
                        icon="icon-trash"
                      ></vs-button>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vs-tab>

          <vs-tab
            :label="'Vendas (' + data.orders.length + ')'"
            icon-pack="feather"
            icon="icon-shopping-cart"
            :disabled="!data.id"
          >
            <div class="tab-text">
              <vs-table class="w-full" noDataText="Nenhum item à listar." :data="data.orders" :stripe="true">
                <template slot="thead">
                  <vs-th class="whitespace-no-wrap">ID INTERNA</vs-th>
                  <vs-th class="whitespace-no-wrap">DATA DA VENDA</vs-th>
                  <vs-th class="whitespace-no-wrap">SITUAÇÃO</vs-th>
                  <vs-th class="whitespace-no-wrap">NÚMERO</vs-th>
                  <vs-th class="whitespace-no-wrap">TOTAL</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :data="tr" v-for="(tr, idx) in data" :key="idx">
                    <vs-td valign="top">
                      <router-link :to="{ name: 'venda-detalhes', params: { id: data[idx].id } }"
                        >{{ data[idx].id }}
                      </router-link>
                    </vs-td>
                    <vs-td valign="top" class="whitespace-no-wrap">{{ data[idx].created_at | formatDateTime }}</vs-td>
                    <vs-td valign="top">{{ data[idx].status }}</vs-td>
                    <vs-td valign="top">
                      <router-link :to="{ name: 'venda-detalhes', params: { id: data[idx].id } }"
                        >{{ data[idx].number }}
                      </router-link>
                    </vs-td>
                    <vs-td valign="top">{{ data[idx].total | money(data[idx].currency_code) }}</vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vs-tab>

          <vs-tab
            :label="'Assinaturas (' + subscriptionsList.length + ')'"
            icon-pack="feather"
            icon="icon-rotate-cw"
            :disabled="!data.id"
          >
            <div class="tab-text">
              <div class="vx-row mb-4">
                <div class="vx-col">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-save"
                    color="success"
                    @click="promptCreateSubscription = true"
                    >Cadastrar Nova Assinatura
                  </vs-button>
                </div>
                <div class="vx-col">
                  <div
                    v-for="subscriptionStatus in subscriptionStatuses"
                    :key="subscriptionStatus.valueFilter"
                    class="inline-block"
                  >
                    <vs-checkbox v-model="subscriptionFilter" :vs-value="subscriptionStatus.valueFilter">{{
                      subscriptionStatus.label
                    }}</vs-checkbox>
                  </div>
                </div>
              </div>

              <vs-table class="w-full" noDataText="Nenhum item à listar." :data="subscriptionsList" :stripe="true">
                <template slot="thead">
                  <vs-th class="whitespace-no-wrap">ID INTERNA</vs-th>
                  <vs-th class="whitespace-no-wrap">ID GATEWAY</vs-th>
                  <vs-th class="whitespace-no-wrap">DATA</vs-th>
                  <vs-th class="whitespace-no-wrap">PLANO</vs-th>
                  <vs-th class="whitespace-no-wrap">DISPOSITIVO</vs-th>
                  <vs-th class="whitespace-no-wrap">SITUAÇÃO</vs-th>
                  <vs-th class="whitespace-no-wrap">RENOVA EM</vs-th>
                  <vs-th class="whitespace-no-wrap">HISTÓRICO</vs-th>
                  <vs-th class="whitespace-no-wrap">&nbsp;</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :data="tr" v-for="(tr, idx) in data" :key="idx">
                    <vs-td valign="top">
                      <router-link :to="{ name: 'assinatura-detalhes', params: { id: data[idx].id } }"
                        >{{ data[idx].id }}
                      </router-link>
                    </vs-td>
                    <vs-td valign="top">
                      <a
                        :href="`https://www.paypal.com/billing/subscriptions/${data[idx].paypal_subscription_id}`"
                        v-if="data[idx].paypal_subscription_id"
                        target="_blank"
                        >{{ data[idx].paypal_subscription_id }}
                        <br />
                        <small>PayPal</small>
                      </a>
                      <a
                        :href="`https://dashboard.stripe.com/subscriptions/${data[idx].stripe_subscription_id}`"
                        target="_blank"
                        v-if="data[idx].stripe_subscription_id"
                      >
                        {{ data[idx].stripe_subscription_id }}
                        <br />
                        <small>Stripe</small>
                      </a>
                      <a
                        :href="`https://alia.iugu.com/receive/billing/${data[idx].iugu_subscription_id}`"
                        target="_blank"
                        v-if="data[idx].iugu_subscription_id"
                      >
                        {{ data[idx].iugu_subscription_id }}
                        <br />
                        <small>Iugu</small>
                      </a>
                      <a
                        :href="`https://alia.iugu.com/receive/billing/${data[idx].iugu_subscription_id}`"
                        target="_blank"
                        v-if="data[idx].iugu_subscription_id"
                      >
                        {{ data[idx].iugu_subscription_id }}
                        <br />
                        <small>Iugu</small>
                      </a>

                      <a
                        :href="
                          `https://app.galaxpay.com.br/detalhes-contrato-venda/${data[idx].galaxpay_subscription_id}`
                        "
                        target="_blank"
                        v-if="data[idx].galaxpay_subscription_id"
                      >
                        {{ data[idx].galaxpay_subscription_id }}
                        <br />
                        <small>GalaxPay</small>
                      </a>
                    </vs-td>
                    <vs-td valign="top" class="whitespace-no-wrap">{{ data[idx].created_at | formatDateTime }}</vs-td>
                    <vs-td valign="top" v-if="data[idx].plan">{{ data[idx].plan.name }}</vs-td>
                    <vs-td valign="top" v-else>-</vs-td>
                    <vs-td valign="top" v-if="data[idx].mobile && data[idx].mobile.id"
                      >{{ data[idx].mobile.alias || data[idx].mobile.device }}<br /><small
                        >(ID {{ data[idx].mobile.id }})</small
                      ></vs-td
                    >
                    <vs-td valign="top" v-else-if="data[idx].device_id" class="bg-danger text-white"
                      ><small><em>Assinatura vinculada à um dispositivo excluído</em></small></vs-td
                    >
                    <vs-td valign="top" v-else
                      ><small><em>Não vinculada à nenhum dispositivo</em></small></vs-td
                    >
                    <vs-td valign="top">{{ data[idx].status }}</vs-td>
                    <vs-td valign="top">{{ data[idx].renew_at | formatDate }}</vs-td>
                    <vs-td valign="top">
                      <div v-for="history in data[idx].history" :key="history.id">
                        <div v-if="history.transaction_data.indexOf('{') === -1">
                          <div>
                            <strong>{{ history.created_at | formatDateTime }}</strong>
                          </div>
                          {{ history.transaction_data }}
                        </div>
                      </div>
                    </vs-td>
                    <vs-td valign="top">
                      <vs-button
                        class="w-full"
                        color="primary"
                        size="small"
                        @click="transferSubscription(data, idx)"
                        icon-pack="feather"
                        icon="icon-arrow-right-circle"
                        >Transferir
                      </vs-button>
                      <vs-button
                        class="mt-2 w-full"
                        color="dark"
                        size="small"
                        @click="editSubscription(data, idx)"
                        icon-pack="feather"
                        icon="icon-edit"
                        >Editar
                      </vs-button>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vs-tab>

          <vs-tab
            :label="'Observações (' + data.notes.length + ')'"
            icon-pack="feather"
            icon="icon-menu"
            :disabled="!data.id"
          >
            <div class="tab-text">
              <vs-table class="w-full" noDataText="Nenhum item à listar." :data="data.notes" :stripe="true">
                <template slot="thead">
                  <vs-th class="whitespace-no-wrap">ADICIONADA POR</vs-th>
                  <vs-th class="whitespace-no-wrap">ADICIONADA EM</vs-th>
                  <vs-th>OBSERVAÇÃO</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :data="tr" v-for="(tr, idx) in data" :key="idx">
                    <vs-td valign="top" class="whitespace-no-wrap" v-if="data[idx].admin"
                      >{{ data[idx].admin.name }}
                    </vs-td>
                    <vs-td valign="top" class="whitespace-no-wrap" v-else>-</vs-td>
                    <vs-td valign="top" class="whitespace-no-wrap">{{ data[idx].created_at | formatDateTime }}</vs-td>
                    <vs-td valign="top" v-html="data[idx].notes"></vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>

    <vs-prompt
      color="danger"
      @accept="confirmDeleteLicence"
      :active.sync="promptDeleteLicence"
      accept-text="Sim"
      cancel-text="Não"
      title="Excluir Licença"
    >
      Confirma a exclusão da licença?
      <div class="con-exemple-prompt">
        <vs-textarea
          class="w-100"
          v-model="licenceToDelete.notes"
          rows="4"
          placeholder="Motivo da exclusão (obrigatório)"
        ></vs-textarea>
      </div>
    </vs-prompt>

    <vs-prompt
      color="success"
      @accept="saveNewLicence"
      :active.sync="confirmNewLicence"
      accept-text="Sim"
      cancel-text="Não"
      title="Cadastrar Nova Licença"
    >
      Confirma o cadastro de
      <strong>{{ newLicence.quantity }}</strong>
      licença(s)?
      <div class="con-exemple-prompt">
        <vs-textarea
          class="w-100"
          v-model="newLicence.notes"
          rows="4"
          placeholder="Motivo do cadastramento (opcional)"
        ></vs-textarea>
      </div>
    </vs-prompt>

    <vs-prompt
      color="success"
      @accept="saveEditedLicence"
      :active.sync="showEditLicence"
      accept-text="Confirmar"
      cancel-text="Cancelar"
      title="Editar Licença"
    >
      <h2>{{ licenceToEdit.alias || licenceToEdit.device || 'Sem Apelido' }}</h2>

      <div class="mt-4">
        <strong>Validade Atual</strong>
      </div>
      <span v-if="licenceToEdit.licence_valid_until">{{ licenceToEdit.licence_valid_until | formatDate }}</span>
      <span v-else>-</span>

      <vs-input
        class="w-full mt-4"
        label="Dias à Adicionar"
        v-model="licenceToEdit.days_to_add"
        :disabled="licenceToEdit.days_to_remove > 0"
        placeholder="0"
      />

      <vs-input
        class="w-full mt-4"
        label="Dias à Remover"
        v-model="licenceToEdit.days_to_remove"
        :disabled="licenceToEdit.days_to_add > 0"
        placeholder="0"
      />

      <div class="con-exemple-prompt mt-4">
        <vs-textarea
          class="w-100"
          v-model="licenceToEdit.notes"
          rows="4"
          placeholder="Motivo da edição (opcional)"
        ></vs-textarea>
      </div>

      <div class="mt-2">
        <strong>Nota:</strong> Se remover dias demais e a nova data de validade ficar no passado, a data de validade
        será configurada para o dia de ontem.
      </div>
    </vs-prompt>

    <vs-prompt
      color="success"
      @accept="doTransferLicence"
      :active.sync="promptTransferLicence"
      accept-text="Confirmar"
      cancel-text="Cancelar"
      title="Transferir Assinatura"
    >
      <h2>{{ licenceToTransfer.id }}</h2>

      <div class="my-4">Você quer transferir a licença para outro dispositivo nessa conta?</div>

      <vs-radio v-model="licenceToTransfer.destination" :vs-value="2" vs-name="destination" class="mr-4"
        >Outro Dispositivo</vs-radio
      >

      <div v-if="licenceToTransfer.destination === 2">
        <div class="mt-4">
          <strong>Para qual dispositivo transferir?</strong>
        </div>

        <div class="mt-4">
          <v-select class="w-full" :options="devices" :clearable="false" v-model="licenceToTransfer.deviceId" />
        </div>

        <div class="mt-4 bg-danger text-white p-4 rounded">
          <strong
            >Atenção: A licença será simplesmente transferida para o dispositivo desejado.<br />Nenhuma alteração na
            data da validade do dispositivo será feita.<br />Se precisar ajustar a data de validade do dispositivo, gere
            uma licença manualmente.</strong
          >
        </div>
      </div>

      <div class="con-exemple-prompt mt-4" v-if="licenceToTransfer.destination > 0">
        <vs-textarea
          class="w-100"
          v-model="licenceToTransfer.notes"
          rows="4"
          placeholder="Motivo da transferência (opcional)"
        ></vs-textarea>
      </div>
    </vs-prompt>

    <vs-prompt
      color="success"
      @accept="doTransferSubscription"
      :active.sync="promptTransferSubscription"
      accept-text="Confirmar"
      cancel-text="Cancelar"
      title="Transferir Assinatura"
    >
      <h2>{{ subscriptionToTransfer.id }}</h2>

      <div class="my-4">Você quer transferir a assinatura para outro email ou para outro dispositivo nessa conta?</div>

      <vs-radio v-model="subscriptionToTransfer.destination" :vs-value="1" vs-name="destination" class="mr-4"
        >Outro E-mail</vs-radio
      >
      <vs-radio v-model="subscriptionToTransfer.destination" :vs-value="2" vs-name="destination" class="mr-4"
        >Outro Dispositivo</vs-radio
      >

      <div v-if="subscriptionToTransfer.destination === 1">
        <div class="mt-4">
          <strong>Para qual email transferir?</strong>
        </div>

        <vs-input
          class="w-full mt-4"
          label="E-mail da nova conta"
          v-model="subscriptionToTransfer.email"
          placeholder="Digite ou cole o e-mail para transferir assinatura"
          autofocus
        />
      </div>

      <div v-if="subscriptionToTransfer.destination === 2">
        <div class="mt-4">
          <strong>Para qual dispositivo transferir?</strong>
        </div>

        <div class="mt-4">
          <v-select class="w-full" :options="devices" :clearable="false" v-model="subscriptionToTransfer.deviceId" />
        </div>

        <div class="mt-4 bg-danger text-white p-4 rounded">
          <strong
            >Atenção: A assinatura será simplesmente transferida para o dispositivo desejado.<br />Nenhuma alteração na
            data da validade do dispositivo será feita.<br />Se precisar ajustar a data de validade do dispositivo, gere
            uma licença manualmente.</strong
          >
        </div>
      </div>

      <div class="con-exemple-prompt mt-4" v-if="subscriptionToTransfer.destination > 0">
        <vs-textarea
          class="w-100"
          v-model="subscriptionToTransfer.notes"
          rows="4"
          placeholder="Motivo da transferência (opcional)"
        ></vs-textarea>
      </div>
    </vs-prompt>

    <vs-prompt
      color="success"
      @accept="doEditSubscription"
      :active.sync="promptEditSubscription"
      accept-text="Confirmar"
      cancel-text="Cancelar"
      title="Editar Assinatura"
    >
      <h2>{{ subscriptionToTransfer.id }}</h2>

      <div class="mt-4">
        <strong>Situação</strong>
      </div>

      <div class="mt-4"><label class="vs-input--label">Situação</label></div>
      <v-select
        class="w-full"
        :options="subscriptionStatuses"
        :clearable="false"
        v-model="subscriptionToEdit.newStatus"
      />

      <div class="mt-4 bg-danger text-white p-4 rounded">
        <strong>A situação do meio de pagamento irá sobrescrever mesmo mudando aqui.</strong>
      </div>
    </vs-prompt>

    <vs-prompt
      color="success"
      @accept="doCreateSubscription"
      :active.sync="promptCreateSubscription"
      accept-text="Salvar"
      cancel-text="Cancelar"
      title="Nova Assinatura"
    >
      <vs-input
        class="w-full mt-4"
        label="ID de assinatura do Iugu"
        v-model="subscriptionToCreate.iugu_subscription_id"
        placeholder="Assinaturas da Iugu tem 32 caracteres"
        v-show="iuguActive"
      />

      <vs-input
        class="w-full mt-4"
        label="ID de assinatura do PayPal"
        v-model="subscriptionToCreate.paypal_subscription_id"
        placeholder="Assinaturas do PayPal começam com I-"
        v-show="payPalActive"
      />

      <vs-input
        class="w-full mt-4"
        label="ID de assinatura do Stripe"
        v-model="subscriptionToCreate.stripe_subscription_id"
        placeholder="Assinaturas do Stripe começam com sub_"
        v-show="stripeActive"
      />

      <div class="mt-4"><label class="vs-input--label">Plano</label></div>
      <v-select class="w-full" :options="plans" :clearable="false" v-model="subscriptionToCreate.plan" />

      <div class="mt-4"><label class="vs-input--label">Situação</label></div>
      <v-select
        class="w-full"
        :options="subscriptionStatuses"
        :clearable="false"
        v-model="subscriptionToCreate.status"
      />

      <vs-input
        class="w-full mt-4"
        label="Data da Próxima Renovação"
        v-model="subscriptionToCreate.renew_at"
        type="date"
      />

      <vs-input class="w-full mt-4" label="Valor" v-model="subscriptionToCreate.amount" placeholder="Valor" />
    </vs-prompt>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import Desktop from './Desktop';
import Mobile from './Mobile';

export default {
  components: {
    Desktop,
    Mobile,
    'v-select': vSelect
  },
  data() {
    return {
      data: {
        status: 1,
        status_reason: 1,
        orders: [],
        desktop: [],
        licences: [],
        subscriptions: [],
        notes: [],
        mobile: []
      },
      filters: {
        status: {
          options: ['ACTIVE', 'TRIAL', 'EXPIRED'],
          selected: []
        },
        device: null
      },
      userRoles: [],
      plans: [],
      confirmNewLicence: false,
      newLicence: {
        quantity: 1
      },
      promptDeleteLicence: false,
      licenceToDelete: {},
      showEditLicence: false,
      licenceToEdit: {},
      promptEditSubscription: false,
      subscriptionToEdit: {},
      promptTransferSubscription: false,
      promptTransferLicence: false,
      subscriptionToTransfer: {},
      licenceToTransfer: {},
      promptCreateSubscription: false,
      subscriptionToCreate: {
        status: { label: 'Ativa', value: 'ACTIVE' }
      },
      subscriptionFilter: ['Ativa'],
      subscriptionStatuses: [
        {
          label: 'Ativa',
          value: 'ACTIVE',
          valueFilter: 'Ativa'
        },
        {
          label: 'Suspensa/Vencida',
          value: 'SUSPENDED',
          valueFilter: 'Suspensa'
        },
        {
          label: 'Cancelada',
          value: 'CANCELLED',
          valueFilter: 'Cancelada'
        }
      ],
      devices: [],
      iuguActive: process.env.VUE_APP_IUGU_ACTIVE === 'true',
      payPalActive: process.env.VUE_APP_PAYPAL_ACTIVE === 'true',
      stripeActive: process.env.VUE_APP_STRIPE_ACTIVE === 'true'
    };
  },

  computed: {
    subscriptionsList() {
      return this.data.subscriptions.filter(i => {
        return this.subscriptionFilter.indexOf(i.status) > -1;
      });
    }
  },

  mounted() {
    this.$vs.loading();

    this.userRoles = JSON.parse(localStorage.getItem('user')).roles || [];

    this.$api
      .get('/api/v1/backend/plans')
      .then(response => {
        this.plans = [];
        response.data.forEach(plan => {
          switch (plan.interval_unit) {
            case 'MONTH':
              plan.interval_unit = 'Mês';
              if (plan.interval_count > 1) {
                plan.interval_unit = 'Meses';
              }

              break;
            case 'YEAR':
              plan.interval_unit = 'Ano';
              if (plan.interval_count > 1) {
                plan.interval_unit = 'Anos';
              }

              break;
          }

          let setupFee = parseFloat(plan.setup_fee) > 0 ? `/R$${plan.setup_fee}` : '';
          this.plans.push({
            label: `${plan.name} (${plan.interval_count} ${plan.interval_unit}) (id: ${plan.id}) - R$${plan.fixed_price}${setupFee}`,
            value: plan.id
          });
        });
      })
      .catch(error => {
        this.$vs.notify({
          title: 'Erro',
          text: error.response.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      });

    // this.load()

    let filters = JSON.parse(localStorage.getItem(`filters-${this.$route.fullPath}`));

    if (filters) {
      this.filters = filters;
    }

    const query = this.$route.query;

    if (query.status) {
      this.filters.status.selected = query.status.split(',');
    }

    this.load();

    // if (this.$route.query.device && !this.filters.device) {
    //   if (!filters) {
    //     filters = {
    //       device: null
    //     }
    //   }

    //   filters.device = this.$route.query.device
    // }

    // if (filters) {
    //   filters.status.options = this.filters.status.options
    //   filters.licenca.options = this.filters.licenca.options
    //   this.filters = filters
    // }

    // const query = this.$route.query
    // if (query.status) {
    //   this.filters.status.selected = [query.status]
    // }

    // if (query.licenca) {
    //   this.filters.licenca.selected = [query.licenca]
    // }

    // if (filters) {
    //   this.filters = filters
    // } else {
    //   this.load()
    // }
  },

  methods: {
    load() {
      if (typeof this.$route.params.id === 'undefined') {
        setTimeout(() => this.$vs.loading.close());
        return;
      }

      localStorage.setItem(`filters-${this.$route.fullPath}`, JSON.stringify(this.filters));
      this.$api
        .get(`/api/v1/backend/customer/${this.$route.params.id}`)
        .then(response => {
          this.$vs.loading.close();
          this.data = response.data;

          if (this.data.mobile) {
            this.devices = [];
            this.data.mobile.forEach(device => {
              this.devices.push({
                label: `${device.alias || device.device} (ID ${device.id})`,
                value: device.id
              });
            });

            if (this.filters && this.filters.status.selected.length > 0) {
              this.data.mobile = this.data.mobile.filter(device =>
                this.filters.status.selected.includes(device.status)
              );
            }

            if (this.filters && this.filters.device) {
              this.data.mobile = this.data.mobile.filter(device => device.device === this.filters.device);
            }
          }
        })
        .catch(error => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: 'Erro',
            text: error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    },
    save() {
      this.$vs.loading();
      let url = '/api/v1/backend/customer';
      let method = 'post';
      if (parseInt(this.$route.params.id) > 0) {
        url += `/${this.$route.params.id}`;
        method = 'patch';
      }

      this.$api({
        url,
        method,
        data: this.data
      })
        .then(response => {
          this.$vs.loading.close();
          this.data = response.data;

          if (typeof this.$route.params.id === 'undefined') {
            this.$router.push({ name: 'cliente-detalhes', params: { id: this.data.id } });
          }

          this.$vs.notify({
            text: 'Salvo',
            color: 'success'
          });
        })
        .catch(error => {
          this.$vs.loading.close();
          let errors = [];
          if (error.response.data.message) {
            errors.push(error.response.data.message);
          } else {
            for (const key in error.response.data) {
              if (Object.hasOwnProperty.call(error.response.data, key)) {
                const element = error.response.data[key];
                errors.push(element);
              }
            }
          }
          this.$vs.notify({
            time: 6000,
            text: errors.join('<br>'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    },
    deleteLicence(data, idx) {
      this.licenceToDelete = data[idx];
      this.licenceToDelete.idx = idx;
      this.promptDeleteLicence = true;
    },
    confirmDeleteLicence() {
      this.$vs.loading();

      this.$api
        .post(`/api/v1/backend/customer/${this.$route.params.id}/delete-licence`, this.licenceToDelete)
        .then(response => {
          this.licenceToDelete = {};
          this.$vs.loading.close();

          this.data = response.data;

          this.$vs.notify({
            text: 'Excluída',
            color: 'success'
          });
        })
        .catch(error => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: 'Erro',
            text: error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    },
    editLicence(device) {
      this.licenceToEdit = device;
      this.showEditLicence = true;
    },
    saveEditedLicence() {
      if (!parseInt(this.licenceToEdit.days_to_add) && !parseInt(this.licenceToEdit.days_to_remove)) {
        this.$vs.notify({
          title: 'Erro',
          text: 'Você precisa digitar a quantidade de dias à adicionar ou remover.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });

        return;
      }

      this.$vs.loading();

      this.$api
        .post(`/api/v1/backend/customer/${this.$route.params.id}/edit-licence`, this.licenceToEdit)
        .then(() => {
          this.$vs.loading.close();

          this.$vs.notify({
            text: 'Salvo',
            color: 'success'
          });

          this.load();
        })
        .catch(error => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: 'Erro',
            text: error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    },
    transferLicence(data, idx) {
      this.licenceToTransfer = data[idx];
      this.licenceToTransfer.idx = idx;
      this.promptTransferLicence = true;
    },
    transferSubscription(data, idx) {
      this.subscriptionToTransfer = data[idx];
      this.subscriptionToTransfer.idx = idx;
      this.promptTransferSubscription = true;
    },
    editSubscription(data, idx) {
      this.subscriptionToEdit = data[idx];
      this.subscriptionToEdit.idx = idx;
      this.promptEditSubscription = true;
    },
    doEditSubscription() {
      this.$vs.loading();

      this.$api
        .post(`/api/v1/backend/customer/${this.$route.params.id}/save-subscription`, this.subscriptionToEdit)
        .then(() => {
          this.subscriptionToEdit = {};
          this.$vs.loading.close();

          this.$vs.notify({
            text: 'Assinatura salva com sucesso.',
            color: 'success'
          });

          this.load();
        })
        .catch(error => {
          this.$vs.loading.close();
          this.$vs.notify({
            time: 10000,
            title: 'Erro',
            text: error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    },
    doCreateSubscription() {
      this.$vs.loading();

      this.$api
        .post(`/api/v1/backend/customer/${this.$route.params.id}/new-subscription`, this.subscriptionToCreate)
        .then(() => {
          this.$vs.loading.close();

          this.subscriptionToCreate = {
            status: { label: 'Ativa', value: 'ACTIVE' }
          };

          this.$vs.notify({
            text: 'Assinatura criada com sucesso.',
            color: 'success'
          });

          this.load();
        })
        .catch(error => {
          this.$vs.loading.close();

          this.promptCreateSubscription = true;

          let errors = [];
          if (error.response.data.message) {
            errors.push(error.response.data.message);
          } else {
            for (const key in error.response.data) {
              if (Object.hasOwnProperty.call(error.response.data, key)) {
                const element = error.response.data[key];
                errors.push(element);
              }
            }
          }
          this.$vs.notify({
            time: 6000,
            text: errors.join('<br>'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    },
    doTransferLicence() {
      this.$vs.loading();

      this.$api
        .post(`/api/v1/backend/customer/${this.$route.params.id}/transfer-licence`, this.licenceToTransfer)
        .then(() => {
          this.licenceToTransfer = {};
          this.$vs.loading.close();

          this.$vs.notify({
            text: 'Licença transferida com sucesso.',
            color: 'success'
          });

          this.load();
        })
        .catch(error => {
          this.$vs.loading.close();
          this.$vs.notify({
            time: 10000,
            title: 'Erro',
            text: error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    },
    doTransferSubscription() {
      this.$vs.loading();

      this.$api
        .post(`/api/v1/backend/customer/${this.$route.params.id}/transfer-subscription`, this.subscriptionToTransfer)
        .then(() => {
          this.subscriptionToTransfer = {};
          this.$vs.loading.close();

          this.$vs.notify({
            text: 'Assinatura transferida com sucesso.',
            color: 'success'
          });

          this.load();
        })
        .catch(error => {
          this.$vs.loading.close();
          this.$vs.notify({
            time: 10000,
            title: 'Erro',
            text: error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    },
    saveNewLicence() {
      this.$vs.loading();

      this.$api
        .post(`/api/v1/backend/customer/${this.$route.params.id}/new-licence`, this.newLicence)
        .then(response => {
          this.newLicence = { quantity: 1 };
          this.$vs.loading.close();
          this.data = response.data;

          this.$vs.notify({
            text: 'Salvo',
            color: 'success'
          });
        })
        .catch(error => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: 'Erro',
            text: error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    },
    resetPassword() {
      this.$vs.loading();

      this.$api
        .post(`/api/v1/backend/customer/${this.$route.params.id}/reset-password`)
        .then(() => {
          this.$vs.loading.close();

          this.$vs.notify({
            text: 'Enviado',
            color: 'success'
          });
        })
        .catch(error => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: 'Erro',
            text: error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    }
  },

  watch: {
    filters: {
      handler() {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          await this.load();
        }, 600);
      },
      deep: true
    }
  }
};
</script>
